import React from "react";

const PrivacyPolicy = () => {
  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "30px 20px",
        lineHeight: "1.7",
        color: "#333",
        textAlign: "left", // Forces ALL text inside to be left aligned
      }}
    >
      <h1
        style={{
          marginBottom: "20px",
          fontSize: "2rem",
          color: "#222",
          fontWeight: "600",
          textAlign: "left", // Force left alignment even if global CSS overrides
        }}
      >
        Privacy Policy – Speak Bold with KK
      </h1>

      <p>
        At <strong>Speak Bold with KK</strong>, we are committed to protecting
        your personal information. This Privacy Policy explains how we collect,
        use, and secure your data when you use our website, mobile application,
        or services.
      </p>

      <h2
        style={{
          marginTop: "30px",
          fontSize: "1.4rem",
          textAlign: "left",
        }}
      >
        Information We Collect
      </h2>
      <ul style={{ paddingLeft: "20px" }}>
        <li>Name</li>
        <li>Email address</li>
        <li>Usage data for improving services</li>
        <li>Payment information (processed securely by Razorpay)</li>
      </ul>

      <h2
        style={{
          marginTop: "30px",
          fontSize: "1.4rem",
          textAlign: "left",
        }}
      >
        How We Use Your Information
      </h2>
      <ul style={{ paddingLeft: "20px" }}>
        <li>To create and manage your account</li>
        <li>To provide online sessions and premium content</li>
        <li>To improve our services and learning experience</li>
        <li>To send updates, confirmations, and notifications</li>
      </ul>

      <h2
        style={{
          marginTop: "30px",
          fontSize: "1.4rem",
          textAlign: "left",
        }}
      >
        Data Security
      </h2>
      <p>
        We implement industry-standard security measures to protect your
        personal information. We do not sell or share your data with any third
        party, except trusted service providers required to operate Speak Bold
        with KK.
      </p>

      <h2
        style={{
          marginTop: "30px",
          fontSize: "1.4rem",
          textAlign: "left",
        }}
      >
        Third-Party Payment Processing
      </h2>
      <p>
        All payments are securely processed through <strong>Razorpay</strong>.
        Razorpay may collect information under their own privacy policy.
      </p>

      <h2
        style={{
          marginTop: "30px",
          fontSize: "1.4rem",
          textAlign: "left",
        }}
      >
        Changes to This Policy
      </h2>
      <p>
        We may update this policy periodically. Continued use of our services
        indicates acceptance of the updated policy.
      </p>

      <h2
        style={{
          marginTop: "30px",
          fontSize: "1.4rem",
          textAlign: "left",
        }}
      >
        Contact Us
      </h2>
      <p>
        For any questions regarding this Privacy Policy, you can contact us at:
      </p>

      <p>
        <strong>Email:</strong> support@speakboldwithkk.com <br />
        <strong>Location:</strong> Maihar, Madhya Pradesh, India
      </p>
    </div>
  );
};

export default PrivacyPolicy;
